import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from "react-redux";
import * as UTILS from '../../config/utils';
import {Businesses} from '../../config/Helper';
import NewsBlock from './NewsBlock';
import blogApi from "../../api/blogApi";
import SingleSlider from '../../components/SingleSlider';
import $ from "jquery/dist/jquery.js";

class News extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            currentNews: 0,
            news: {
                title: '',
                description: ''
            }
        }
        this.business = Businesses.indexOf('agency_news');
        this.gotoNewsDetail = this.gotoNewsDetail.bind(this);
        this.getNews = this.getNews.bind(this);
    }

    componentWillMount() { 
    }

    componentDidMount() {
        // makeEllipsis('.post-description.giveMeEllipsis2');
        // $(window).on('resize', function(evt) {
        //     makeEllipsis('.post-description.giveMeEllipsis2');
        // })
    }
  
    componentWillUnmount() {
        
    }
  
    componentWillReceiveProps(newProps) {
        this.getNews(this.state.currentNews);
    }

    componentDidUpdate() {
       
    }

    gotoNewsDetail(newsId) {
        this.getNews(newsId);
        window.scrollTop('#newsDetail', 100);

    }

    getNews(newsId) {
        ReactDOM.unmountComponentAtNode(document.getElementById('news_slider_container'));
        blogApi.getBlog(Businesses[this.business], newsId).then((json) => {
            if (json.status === 200 && json.data) {
                
                if (UTILS.stripTag(json.data.title) !== '' && json.data.title !== null) {
                    this.setState({
                        currentNews: newsId,
                        news: json.data,
                    });           
                    
                    ReactDOM.render(<SingleSlider media={json.data.media} business={this.business} id={newsId} title={json.data.title}/>, document.getElementById('news_slider_container'));
                    // window.initSingleSlider();
                    $('#news_slider_container').find('#thumbnail-slide').attr('id', 'thumbnail-slide2');
                    $('#news_slider_container').find('li[data-target="#thumbnail-slide"]').attr('data-target', '#thumbnail-slide2');
                } else {
                    this.setState({
                        currentNews: newsId,
                        news: {},
                    });
                }

                 
                
            } else {
                if (json.status === 620) {
                    // store.dispatch(addNotification(`${lang('access_deny')}`, 'error'));
                } else {
                    // store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
                }
            }            
        }) 
    }
  
    render() {
        return (
            <div className="container">
                <h4 className="mt-4 mb-4">{this.props.newsCaption}</h4>
                <div className="row">
                    <div className="col-md-12">
                    {
                        this.props.news.map((newsItem, key) => (
                            <NewsBlock 
                                key         = {key}
                                business    = {this.business} 
                                id          = {newsItem.id} 
                                title       = {newsItem.title}
                                description = {newsItem.description}
                                image       = {newsItem.media_filename} 
                                media_type  = {newsItem.media_filetype}
                                onClick = {() => this.gotoNewsDetail(newsItem.id)} />
                        ))
                    }
                    </div>
                </div>
                <div id="newsDetail" />
                {
                    this.state.news.title !== '' &&
                    <hr />
                }
                <div className="row ">                    
                    <div className="col-lg-10 offset-lg-1 col-md-12 " style={{float:'left'}}>
                    {
                        this.state.news.title !== '' &&
                        <div className="news-title pt-4 pb-4" dangerouslySetInnerHTML={{__html: this.state.news.title}}  />
                    }
                        <div id="news_slider_container" >
                        </div>                       
                    </div>
                    {
                        this.state.news.description !== '' &&
                        <div className="col-lg-10 offset-lg-1 col-md-12 offset-0 pl-4">
                            <div dangerouslySetInnerHTML={{__html: this.state.news.description}} />
                        </div>
                    }

                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(News);